// Dahsboard

import { useQuery } from '@tanstack/react-query';
import { CessionsSummary } from 'pages/Home/components/Factoring/Wallet/components/Summary/types';
import { TeamSummary } from 'pages/Home/components/Factoring/Wallet/components/TeamSummary/types';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { BusinessesSummaryResponse, FinanciableInvoicesRow } from './types';

export const getInvoiceClaimed = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/invoices/claimed`,
    dispatch,
  });
  if (response) return response.data;
};

export const getInvoiceNotConfirmed = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/invoices/notConfirmed`,
    dispatch,
  });
  if (response) return response.data;
};
export const getOwnInvoiceNotConfirmed = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/invoices/notConfirmed/own`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFinanciableInvoices = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['dashboard', 'invoices', 'financiable'],
    queryFn: async (): Promise<FinanciableInvoicesRow[]> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/users/dashboard/invoices/financiable`,
        dispatch,
      });
      if (response) return response.data;
      return [];
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

export const getAllInvoices = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/invoices/all?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBankrruptcyPosts = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/bankruptcyPosts`,
    dispatch,
  });
  if (response) return response.data;
};
export const getSiiDebt = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/sii/debt`,
    dispatch,
  });
  if (response) return response.data;
};

export const lastSiiMessages = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/sii/messages`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCessionsSummary = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['dashboard', 'cessionsSummary'],
    queryFn: async (): Promise<CessionsSummary | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/users/dashboard/cessions/summary`,
        dispatch,
      });
      if (response) return response.data;
    },
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 1,
  });

export const getTeamSummary = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['dashboard', 'teamSummary'],
    queryFn: async (): Promise<TeamSummary | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/users/dashboard/cessions/teamSummary`,
        dispatch,
      });
      if (response) return response.data;
    },
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 1,
  });

export const lastCessionMonthly = async (
  dispatch: Dispatch,
  month?: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/cessions/monthly${month ? `?month=${month}` : ''}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCompleteTGR = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/tgr`,
    dispatch,
  });
  if (response) return response.data;
};

export const getProspectsData = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/prospects`,
    dispatch,
  });
  if (response) return response.data;
};

export const getPayerSales = async (
  dispatch: Dispatch,
  payerIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/wallet/factorings/buys?payerIdentifier=${payerIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessesSummary = async (
  dispatch: Dispatch,
  query: string,
): Promise<BusinessesSummaryResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/dashboard/businesses/summary?${query}`,
    dispatch,
  });
  if (response) return response.data;
};
